'use client'

import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

interface SideEffectsModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const SideEffectsModal = ({ forceOpened = false, onClose }: SideEffectsModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const router = useRouter();
  
  useEffect(() => {
    if (forceOpened) {
      open();
    }
  }, [forceOpened, open]);

  const generalItems = [
    { label: '마취', path: '/side-effects/anesthesia' },
    { label: '일상생활', path: '/side-effects/daily-life' },
    { label: '정신적', path: '/side-effects/mental' },
    { label: '육체적', path: '/side-effects/physical' }
  ];

  const handleItemClick = (path: string) => {
    router.push(path);
    close();
    if (onClose) onClose();
  };

  const handleClose = () => {
    close();
    if (onClose) onClose();
  };

  return (
      <Modal
        opened={opened}
      onClose={handleClose}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
      <div className="flex flex-col gap-3 mb-5">
        <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
          부작용
        </div>
      </div>
        
      {/* Button Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 max-w-[560px] mx-auto">
        {generalItems.map((item, index) => (
            <div
              key={index}
            className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800`}
            onClick={() => handleItemClick(item.path)}
            >
            <div className="text-[15px] font-normal">
              {item.label}
            </div>
            </div>
          ))}
        </div>
        
      {/* Close Button */}
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
          onClick={handleClose}
          >
            닫기
          </Button>
        </div>
      </Modal>
  );
};